import api from "./api";
import axios from "axios";
import { getUser } from "../services/Auth";

export const SetarTokenFirebase = async (token) => {
  try {
    const usuario = await getUser();
    if (token) {
      await api.put(`/usuarios/${usuario._id}`, { token_firebase: token });
    } else {
      throw new Error("Token nulo");
    }
  } catch (error) {
    throw error;
  }
};

export const EnviarNotificacaoPush = async (mensagem) => {
  try {
    const response = await api.post(`/notificacoes/cliente`, mensagem);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUsuario = async () => {
  try {
    const user = await getUser();
    return user;
  } catch (error) {
    throw error;
  }
};

export const MudarSenhaUsuario = async (senha) => {
  try {
    const user = await getUser();
    await api.put(`/usuarios/${user._id}/`, { senha: senha });
  } catch (error) {
    throw error;
  }
};

export const getCoordenadas = async (dados) => {
  try {
    const apiKey = "AIzaSyBgqV0tL-uM6jO4mKnE_hHsuZ6OVfCCgmU";
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${dados.numero}${dados.rua},${dados.cidade},${dados.estado}&key=${apiKey}`,
    );
    return response.data.results;
  } catch (error) {
    throw error;
  }
};

export const ListarUsuarios = async () => {
  try {
    const usuarios = await api.get(`/usuarios/master`);
    return usuarios.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarUsuario = async (data) => {
  try {
    const usuario = await api.post("/registrar", data);
    return usuario.data;
  } catch (error) {
    throw error;
  }
};

export const EditarUsuario = async (data, id) => {
  try {
    const usuarios = await api.put(`/usuarios/${id}`, data);
    return usuarios.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarUsuario = async (id) => {
  try {
    const usuarios = await api.put(`/usuarios/${id}`);
    return usuarios.data;
  } catch (error) {
    throw error;
  }
};

export const getCEP = async (cep) => {
  try {
    const res = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    return res.data;
  } catch (error) {
    throw error;
  }
};
